<div class="loadable" [class.loading]="isLoading" [ngClass]="'level-' + level">
    <div class="header">
        <mat-checkbox [id]="id" [color]="'primary'" [(ngModel)]="checked" [disabled]="!!disabled">
            {{ label | translate }}
        </mat-checkbox>
    </div>
    <div class="children">
        <ng-content />
    </div>
</div>
